import BloomFormObserver from '../form_observer';

export default class BloomEmailInput {
	static INPUT_SELECTOR = '.et_bloom_popup_input.et_bloom_subscribe_email input';
	static FORM_SELECTOR = '.et_bloom_optin form';
	static SUBSCRIPTION_BUTTON_SELECTOR = '.et_bloom_optin form button';
	static FORM_VALIDATION_ERROR_SELECTOR = '.et_bloom_error_message';
	static FORM_FIELDS_SELECTOR = '.et_bloom_fields';
	static INPUT_LABEL_SELECTOR = '.et_bloom_popup_input.et_bloom_subscribe_email .floating_label';

	start() {
		this.attachEventListeners();
	}

	attachEventListeners() {
		this.onInvalidEmailError();
		this.onPressSubscriptionButton();
	}

	onInvalidEmailError() {
		const $ = jQuery;
		if (!$(BloomEmailInput.FORM_SELECTOR).length) {
			return;
		}
		$(BloomEmailInput.FORM_SELECTOR).get().forEach((element) => {
			const observe = new BloomFormObserver(element);
			observe.onValidationError(() => {
				$(BloomEmailInput.FORM_VALIDATION_ERROR_SELECTOR)
					.attr('role', 'alert')
					.attr('aria-live', 'assertive');
				if (coreAccessibility.enable_bloom_a11y_fixes) {
					$(BloomEmailInput.INPUT_SELECTOR).addClass('et_bloom_warn_required_field').focus();
					$(BloomEmailInput.FORM_SELECTOR).addClass('fl-bloom-error');
				}
			});
		});
	}

	onPressSubscriptionButton() {
		const $ = jQuery;

		$(BloomEmailInput.SUBSCRIPTION_BUTTON_SELECTOR).on('click', (event) => {
			const $formFields = $(event.target).parents(BloomEmailInput.FORM_FIELDS_SELECTOR);
			const $input = $formFields.find(BloomEmailInput.INPUT_SELECTOR);
			$input.removeClass('et_bloom_warn_required_field');
			if (coreAccessibility.enable_bloom_a11y_fixes) {
				$(BloomEmailInput.FORM_SELECTOR).removeClass('fl-bloom-error');
			}
			$formFields.parent().find(BloomEmailInput.FORM_VALIDATION_ERROR_SELECTOR).remove();
			if ($input.val() === '') {
				$input.addClass('et_bloom_warn_required_field');
				const errorMessage = document.createElement('h2');
				errorMessage.innerText = 'Enter your email address';
				errorMessage.classList.add('et_bloom_error_message');
				$(errorMessage).insertBefore($formFields.get());
			}
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/bloom/controllers/bloom_email_input.js